"use client";

import React, { createContext, useContext, useState, useCallback } from "react";

interface ModalContextType {
  // Referral Modal
  isReferralModalVisible: boolean;
  showReferralModal: () => void;
  hideReferralModal: () => void;

  // Can be extended for other modals in the future
}

const ModalContext = createContext<ModalContextType | undefined>(undefined);

export const ModalProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isReferralModalVisible, setIsReferralModalVisible] = useState(false);

  const showReferralModal = useCallback(() => {
    setIsReferralModalVisible(true);
  }, []);

  const hideReferralModal = useCallback(() => {
    setIsReferralModalVisible(false);
  }, []);

  const value: ModalContextType = {
    isReferralModalVisible,
    showReferralModal,
    hideReferralModal,
  };

  return (
    <ModalContext.Provider value={value}>
      {children}
    </ModalContext.Provider>
  );
};

export const useModal = () => {
  const context = useContext(ModalContext);
  if (context === undefined) {
    throw new Error("useModal must be used within a ModalProvider");
  }
  return context;
};